// @flow
import * as React from 'react';
import classNames from 'classnames';

import styles from './Badge.module.scss';;


type Props = {
  value: number,
  className?: string,
}

const Badge = ({ value, className }: Props) => (value
  ? <div className={classNames(styles.root, className)}>
    {value}
  </div>
  : null
);

export default Badge;
